import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./Photos.css";

const images = [
  {
    original: "assets/images/photos/jenks_001.png",
    thumbnail: "assets/images/photos/thumbnails/jenks_001.jpg"
  },
  {
    original: "assets/images/photos/jenks_guitar01.png",
    thumbnail: "assets/images/photos/thumbnails/jenks_guitar01.jpg"
  },
  {
    original: "assets/images/photos/jenks_guitar02.png",
    thumbnail: "assets/images/photos/thumbnails/jenks_guitar02.jpg"
  },
  {
    original: "assets/images/photos/miley001.png",
    thumbnail: "assets/images/photos/thumbnails/miley001.jpg"
  },
  {
    original: "assets/images/photos/oml_001.png",
    thumbnail: "assets/images/photos/thumbnails/oml_001.jpg"
  },
  {
    original: "assets/images/photos/show_001.png",
    thumbnail: "assets/images/photos/thumbnails/show_001.jpg"
  },
  {
    original: "assets/images/photos/show_002.png",
    thumbnail: "assets/images/photos/thumbnails/show_002.jpg"
  },
  {
    original: "assets/images/photos/show_005.png",
    thumbnail: "assets/images/photos/thumbnails/show_005.jpg"
  },
  {
    original: "assets/images/photos/show_006.png",
    thumbnail: "assets/images/photos/thumbnails/show_006.jpg"
  },
  {
    original: "assets/images/photos/show_007.png",
    thumbnail: "assets/images/photos/thumbnails/show_007.jpg"
  },
  {
    original: "assets/images/photos/show_011.png",
    thumbnail: "assets/images/photos/thumbnails/show_011.jpg"
  },
  {
    original: "assets/images/photos/skull001.png",
    thumbnail: "assets/images/photos/thumbnails/skull001.jpg"
  },
  {
    original: "assets/images/photos/skull002.png",
    thumbnail: "assets/images/photos/thumbnails/skull002.jpg"
  },
  {
    original: "assets/images/photos/yng_001.png",
    thumbnail: "assets/images/photos/thumbnails/yng_001.jpg"
  },
  {
    original: "assets/images/photos/yng_002.png",
    thumbnail: "assets/images/photos/thumbnails/yng_002.jpg"
  }
];

function Photo() {
  return (
    <div className="text-center text-2xl">
      <ImageGallery
        items={images}
        thumbnailPosition="top"
        showThumbnails={true}
        showFullscreenButton={true}
        showPlayButton={false}
        autoPlay={false}
        renderThumbInner={(item) => (
          <div className="thumbnail-container">
            <img src={item.thumbnail} alt="" className="thumbnail-image" />
          </div>
        )}
      />
    </div>
  );
}

export default Photo;
